import zindex from '!!sass-variable-loader!./_zindex.scss';

export default zindex;
